import type { UploadedAsset } from '@shared/types/file-upload.types'
import type { ContactChannel } from '../components/page'

interface BaseFormData {
  intentId: string
  firstName: string
  lastName: string
  email: string
  countryCode: string
  country: string
  description: string
  selectedLineItemIds: string[]
  selectedWorkIds: string[]
  orderNumber: string
  websiteDomain: string
}

export interface CallbackFormData extends BaseFormData {
  channel: 'callback'
  phone: string
  parentCategory: string
  optInRecording: boolean
}

export interface EmailFormData extends BaseFormData {
  channel: 'email'
  attachments: UploadedAsset[]
}

export type ContactFormData = CallbackFormData | EmailFormData

export const buildInitialFormData = (channel: ContactChannel): ContactFormData => {
  const base: BaseFormData = {
    intentId: '',
    firstName: '',
    lastName: '',
    email: '',
    countryCode: '',
    country: '',
    description: '',
    selectedLineItemIds: [],
    selectedWorkIds: [],
    orderNumber: '',
    websiteDomain: '',
  }

  if (channel === 'callback') {
    return { ...base, channel: 'callback', phone: '', parentCategory: '', optInRecording: false }
  }
  return { ...base, channel: 'email', attachments: [] }
}
